import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 40 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Kicker({ children, light = false }) {
  return (
    <span className={`inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] ${light ? "text-offwhite/60" : "text-orange"}`}>
      <span className={`w-8 h-px ${light ? "bg-offwhite/40" : "bg-orange"}`} />
      {children}
    </span>
  );
}
